import { FC, PropsWithChildren } from 'react'
import MuiDialog, { DialogProps } from '@mui/material/Dialog'

const Dialog: FC<PropsWithChildren<Omit<DialogProps, 'sx'>>> = ({
  children,
  ...props
}) => {
  return (
    <MuiDialog
      {...props}
      sx={{
        '& .MuiDialog-paper': {
          m: { xs: 0, sm: 4 },
          width: { xs: '100%', sm: 'auto' },
          minWidth: { xs: '100%', sm: '500px' },
        },
        '& .MuiDialog-container': {
          alignItems: { xs: 'flex-end', sm: 'center' },
        },
      }}
    >
      {children}
    </MuiDialog>
  )
}
export default Dialog
